export interface IDriverDeviceInputDto {
    lastReportDate?: string;
    appVersion?: string;
}
